import type {CitationFile} from "../types";

/** Inline photo row for print/PDF — no frames; images sit next to each other and wrap. */
export function CitationPrintPhotoGrid({files}: {files: CitationFile[]}) {
  if (!files.length) return null;

  return (
    <div className="flex flex-wrap items-start gap-2">
      {files.map((file, index) => (
        <img
          key={`${file.id}-${index}`}
          src={file.url}
          alt={`Photo ${index + 1}`}
          className="max-h-40 w-auto max-w-[calc(50%-0.25rem)] object-contain break-inside-avoid"
        />
      ))}
    </div>
  );
}
